import { a as i, b as o } from "../tslib.es6-CH0JWuEm.mjs";
import { useState as l, useRef as q, useEffect as I } from "react";
var x = function(c) {
  var s = c.slugs, f = c.skip, p = f === void 0 ? !1 : f, v = l(/* @__PURE__ */ new Map()), b = v[0], y = v[1], d = l(!1), E = d[0], h = d[1], m = l(null), M = m[0], g = m[1], w = q([]);
  return I(function() {
    if (!p) {
      var k = function(r, t) {
        if (r.length !== t.length)
          return !1;
        for (var e = 0; e < r.length; e++)
          if (r[e] !== t[e])
            return !1;
        return !0;
      };
      if (!k(w.current, s)) {
        w.current = s;
        var R = function(r) {
          return i(void 0, void 0, void 0, function() {
            var t;
            return o(this, function(e) {
              switch (e.label) {
                case 0:
                  return [4, fetch("/api/v4/apps/".concat(encodeURIComponent(r)))];
                case 1:
                  if (t = e.sent(), !t.ok)
                    throw new Error('Failed to fetch app details for "'.concat(r, '"'));
                  return [2, t.json()];
              }
            });
          });
        }, _ = function() {
          return i(void 0, void 0, void 0, function() {
            var r, t, e;
            return o(this, function(a) {
              switch (a.label) {
                case 0:
                  h(!0), g(null), a.label = 1;
                case 1:
                  return a.trys.push([1, 3, 4, 5]), r = Array.from(new Set(s)), [4, Promise.allSettled(r.map(function(n) {
                    return i(void 0, void 0, void 0, function() {
                      var u, A, D;
                      return o(this, function(S) {
                        switch (S.label) {
                          case 0:
                            return [4, R(n)];
                          case 1:
                            return u = S.sent(), A = u.image, D = u.name, [2, [n, { image: A, name: D }]];
                        }
                      });
                    });
                  }))];
                case 2:
                  return t = a.sent(), y(new Map(t.filter(function(n) {
                    return n.status === "fulfilled";
                  }).map(function(n) {
                    return n.value;
                  }))), [3, 5];
                case 3:
                  return e = a.sent(), g(e), [3, 5];
                case 4:
                  return h(!1), [
                    7
                    /*endfinally*/
                  ];
                case 5:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        };
        _();
      }
    }
  }, [s, p]), { data: b, isLoading: E, error: M };
};
export {
  x as useAppDetailsBySlugs
};
//# sourceMappingURL=useAppDetailsBySlugs.es.js.map
